import RingLoader from "react-spinners/RingLoader";

const ModalCheck = (props) => {
  const handleCloseModal = () => {
    props.onCloseModal();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className="modal-backdrop fade show"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.95) !important",
          zIndex: 20,
        }}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show" // phải có show để model hiển thị
        style={{ display: "block", zIndex: 30 }}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{
            position: "fixed",
            left: "10%",
            width: "80%",
            height: "auto",
            maxWidth: "none", // Overrides default Bootstrap modal size
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-primary" id="staticBackdropLabel">
                Kết quả kiểm tra
              </h5>
            </div>

            <div className="modal-body d-flex justify-content-center align-items-center text-danger">
              {props.loading ? (
                <RingLoader color="#36d7b7" size={80} />
              ) : (
                props.message
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleCloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalCheck;
